// AddCardModal.jsx
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
} from '@mui/material';
import { useMaterialUIController } from "../../../../context";

export default function AddCardModal({
                                         open,
                                         onClose,
                                         onSubmit,
                                         onDelete,          // ⬅️ אופציונלי – למחיקה במצב עריכה
                                         userEmail,
                                         mode = "add",      // "add" | "edit"
                                         initialTitle = "",
                                         initialPlaceId = "",
                                     }) {
    const isEdit = mode === "edit";

    const [title, setTitle] = useState(initialTitle);
    const [placeId, setPlaceId] = useState(initialPlaceId);

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const textColor = darkMode ? "#fff" : "#000";
    const cardBgColor = darkMode ? "#1e293b" : "#fff";

    // בכל פתיחה של המודל נטען ערכים מחדש
    useEffect(() => {
        if (!open) return;
        if (isEdit) {
            setTitle(initialTitle || "");
            setPlaceId(initialPlaceId || "");
        } else {
            setTitle("");
            setPlaceId("");
        }
    }, [open, isEdit, initialTitle, initialPlaceId]);

    const handleSubmit = () => {
        if (title && placeId) {
            onSubmit({
                title,
                place_id: placeId,
                user_email: userEmail,
            });
        }
    };

    return (
        <Dialog
            PaperProps={{
                sx: {
                    backgroundColor: cardBgColor,
                    color: textColor,
                },
            }}
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                {isEdit ? "Edit Place" : "Add New Place"}
            </DialogTitle>

            <DialogContent>
                <TextField
                    fullWidth
                    margin="normal"
                    label="Place Name"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Place ID"
                    value={placeId}
                    onChange={(e) => setPlaceId(e.target.value)}
                />
            </DialogContent>

            <DialogActions>
                {isEdit && onDelete && (
                    <Button color="error" onClick={onDelete}>
                        Delete
                    </Button>
                )}
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">
                    {isEdit ? "Save" : "Add"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}